import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import DataTable from "../../components/DataTable";
import Modal from "../../components/Modal";
import Alert from "../../components/Alert";
import { listAuditLogs } from "../../api/auditApi";
import "../Users/UsersPage.css";
import "./AuditLogPage.css";

export default function AuditLogPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    listAuditLogs()
      .then(setLogs)
      .catch(() => setError("Failed to load audit logs."))
      .finally(() => setLoading(false));
  }, []);

  const columns = [
    { key: "performedAt", label: "When", render: (row) => (row.performedAt ? new Date(row.performedAt).toLocaleString() : "") },
    { key: "entityName", label: "Entity" },
    { key: "entityId", label: "Entity ID" },
    { key: "action", label: "Action" },
    { key: "operateBy", label: "Performed By" },
  ];

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Audit Log</h1>
      </div>

      <Alert type="error" onDismiss={() => setError("")}>
        {error}
      </Alert>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <DataTable
          columns={columns}
          rows={logs}
          emptyMessage="No audit activity recorded for this institute yet."
          actions={(row) => (
            <button type="button" className="btn-link" onClick={() => setSelected(row)}>
              View
            </button>
          )}
        />
      )}

      {selected && (
        <Modal title={`Audit #${selected.id} — ${selected.entityName}`} onClose={() => setSelected(null)}>
          <pre className="audit-json">{JSON.stringify(selected.snapshot || selected.changedFields, null, 2)}</pre>
        </Modal>
      )}
    </MainLayout>
  );
}
